import React from 'react';
import PropTypes from 'prop-types';
import Container from './container';

const SELECT_CLASS_NAME = 'floating-label-text-area';

export const TextArea = props => (
    <Container
        name={props.name}
        label={props.label}
        hasValue={props.value !== ''}
        highlight={props.highlight}
        disabled={props.disabled}
        loading={props.loading}
        hintText={props.hintText}
        errorText={props.errorText}
        invalid={props.invalid}
        additionalClassNames={[SELECT_CLASS_NAME].concat(props.additionalClassNames)}
    >
        <textarea className="floating-label-text-area__input"
            id="textarea" charswidth="23"
            defaultValue={props.value}
            name={props.name}
            disabled={props.disabled}
            maxLength={props.maxLength}
            placeholder={props.label}
            onChange={event => props.onChange(event.target.value, props.name)} />

    </Container>
);

TextArea.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    highlight: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    hintText: PropTypes.string,
    errorText: PropTypes.string,
    invalid: PropTypes.bool,
    additionalClassNames: PropTypes.array,
    maxLength: PropTypes.string,
};


TextArea.defaultProps = {
    additionalClassNames: [],
    maxLength: '524288', // html default for this attribute,
};

export default TextArea;
